import { render } from "./ServersCard.vue?vue&type=template&id=773e4269"
import script from "./ServersCard.vue?vue&type=script&lang=ts"
export * from "./ServersCard.vue?vue&type=script&lang=ts"

import "./ServersCard.vue?vue&type=style&index=0&id=773e4269&lang=css"
script.render = render

export default script